<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('products.termination_rules.name')"
            :is-required="true"
            :error="errors.name"
        >
            <DInput
                id="termination-rules-name"
                v-model="form.name"
                :is-valid="isFormFieldValid('name')"
            />
        </DFormRow>
        <DFormRow
            :label="__('products.termination_rules.notification')"
            :error="errors.notification"
        >
            <DInput
                id="termination-rules-notification"
                v-model="form.notification"
                :is-valid="isFormFieldValid('notification')"
            />
        </DFormRow>
        <DFormRow
            :label="__('products.termination_rules.suspension')"
            :error="errors.suspension"
        >
            <DInput
                id="termination-rules-suspension"
                v-model="form.suspension"
                :is-valid="isFormFieldValid('suspension')"
            />
        </DFormRow>
        <DFormRow
            :label="__('products.termination_rules.auto_renew')"
            :error="errors.auto_renew"
        >
            <DInput
                id="termination-rules-auto_renew"
                v-model="form.auto_renew"
                :is-valid="isFormFieldValid('auto_renew')"
            />
        </DFormRow>
        <DFormRow
            :label="__('products.termination_rules.deletion')"
            :is-required="true"
            :error="errors.deletion"
        >
            <DInput
                id="termination-rules-deletion"
                v-model="form.deletion"
                :is-valid="isFormFieldValid('deletion')"
            />
        </DFormRow>
        <DFormControls
            :cancel-route="cancelRoute"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { computed } from 'vue'
import { route } from '~@/Composables/route'

const props = defineProps({
    errors: {
        type: Object,
        default: () => {
            return {}
        }
    },
    terminationRule: {
        type: Object,
        default: () => { return {} }
    }
})

const form = useForm({
    name: props.terminationRule?.name,
    notification: props.terminationRule?.notification,
    suspension: props.terminationRule?.suspension,
    auto_renew: props.terminationRule?.auto_renew,
    deletion: props.terminationRule?.deletion
})

const emit = defineEmits(['form-submitted'])

const cancelRoute = computed(() => route('products.termination-rules.index'))

function submitForm () {
    emit('form-submitted', form)
}
</script>
